import { useDispatch } from "react-redux";
import { setProfil } from "../redux";
import { useNavigate } from "react-router-dom";

export const useLogout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const logout = async () => {
        sessionStorage.removeItem('token');
        localStorage.removeItem('save_login');
        localStorage.removeItem('token');

        dispatch(setProfil());
        navigate('/');
        window.location.reload();
    }
    return logout;
};